import {memo} from 'react'
import I from '@/components/I'

interface IWritingErrorProps {
    prop?: string;
}

export const WritingError = memo((props: IWritingErrorProps) => {
    const {prop} = props

    return (
        <div className='h100% oh flexc acenter bg#f6f7f8'>
            <div className='flex3'></div>
            <div className='flexc acenter por'>
                <I
                    src='error/error.png'
                    width={120}
                    priority
                />
                <div className='mt16 f14 #8B8FA1'>哎呀！作文批改出错了</div>
                <div className='translate-50%100% b-40 centerx w100vw px56'>
                    <div className='#525461 f12 fw500 nowrap'>以下原因可能导致批改出错，请检查后重新提交：</div>
                    <ul
                        style={{listStyleType: 'disc'}}
                        className='#9698A1 fs12 lh28 #9698A1 mt8 pl1em'
                    >
                        <li>照片中包含不是作文的题目</li>
                        <li>提交的作文和题目不对应</li>
                        <li>字数不够或严重跑题</li>
                        <li>不符合作文作答规范等</li>
                        <li>图片过大或网速较慢等原因导致数据传输失败</li>
                    </ul>
                </div>
            </div>
            <div className='flex7'></div>
        </div>
    )
})
